export default {
      id: "loading-usage",
      viewBox: "0 0 38 38",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#loading",
      toString: function () {
        return this.url;
      }
    }